module.exports = __webpack_public_path__ + "static/img/6.614da4a5.webp";